// extracted by mini-css-extract-plugin
module.exports = {"side":"side___3l2XE","base":"base___2t-YP"};